import SeoLandingPage from "@/components/SeoLandingPage";

const StorageUnitCleanout = () => (
  <SeoLandingPage
    slug="storage-unit-cleanout-wi"
    metaTitle="Storage Unit Cleanout Wisconsin | Inherited & Auction Units"
    metaDescription="Storage unit cleanout in Wisconsin. We empty inherited, auctioned, or abandoned units fast. Sort valuables, donate, and dispose. Free estimate."
    h1="Storage Unit Cleanouts in Wisconsin"
    heroImage="/images/chimney_untouched.jpg"
    heroIntro="Inherited a storage unit you can't bring yourself to open? Bought an auction unit you don't want to haul home? We empty 5x5 lockers and 10x30 drive-ups across Wisconsin in a single trip."
    serviceName="Storage Unit Cleanout"
    bullets={[
      "We meet you (or the facility manager) on-site with a truck and crew.",
      "Sort into keep / donate / dispose right at the unit door.",
      "Lift heavy furniture, safes, and appliances out of the unit for you.",
      "Donation drop-off and itemized receipts.",
      "Sweep the unit clean so you can close out the lease same-day.",
      "Optional cash offer on resaleable contents (auction units).",
    ]}
    whyUs={[
      "We've cleared hundreds of Wisconsin storage units — Public Storage, Extra Space, U-Haul, local lockers.",
      "Bring your own crew? Don't bother — one phone call, done in an afternoon.",
      "Honest assessment if anything inside has resale value.",
      "Insured for damage to the facility and surrounding units.",
    ]}
    processSteps={[
      { title: "Tell us the size and location", detail: "Send a photo of the unit door (or the auction listing) and we'll quote in 15 minutes." },
      { title: "Schedule the haul", detail: "We meet you at the facility during their access hours, usually within 48 hours." },
      { title: "Empty and sort", detail: "Crew empties the unit, sorts on the spot, and loads the truck. You don't lift a thing." },
      { title: "Sweep and close out", detail: "Unit is swept clean, photos sent, and you can hand the keys back to the facility manager." },
    ]}
    faqs={[
      { q: "How much does it cost to clean out a storage unit?", a: "Most 10x10 units in Wisconsin cost $250–$650 to clean out. 10x20 and 10x30 drive-ups run $500–$1,200. We give a firm quote before we touch anything." },
      { q: "I bought an auction unit — can you help?", a: "Yes. We're set up for auction-buyers: bring your invoice, we'll empty the unit the same day. If contents have resale value, we may offer to buy them outright and reduce your bill." },
      { q: "Do you handle inherited units where the contents are emotional?", a: "Absolutely. We slow down, let you pull keepsakes first, and handle the rest with respect. Many of our storage cleanouts are for families settling an estate." },
      { q: "What about hazardous items?", a: "Old paint, propane, batteries, and chemicals are common in storage units. We separate and dispose of them at certified hazardous-waste facilities at no extra charge for small amounts." },
    ]}
    ctaHeadline="One unit, one truck, one afternoon."
  />
);

export default StorageUnitCleanout;
